import styled from "styled-components/macro";

export const ActionButton = styled.button.attrs(({ onClick }) => ({
  // ag-Grid's row-click-to-select listener is a native bubble-phase
  // listener on an ancestor row container, which runs before React's
  // (root-delegated) onClick ever fires - so stopPropagation() from a
  // regular onClick is always too late. onClickCapture runs during the
  // capture phase, ahead of any bubble-phase listener, so it can actually
  // stop the click from reaching ag-Grid's row selection handler.
  onClick: undefined,
  onClickCapture: onClick
    ? event => {
        event.stopPropagation();
        onClick(event);
      }
    : onClick,
}))(
  ({ theme }) => `
  margin: 0 ${theme.space[1]}px;
  padding: ${theme.space[1]}px;
  background-color: transparent;
  border: none;
  border-radius: ${theme.radii[3]}px;
  &:hover:enabled {
    background-color: ${theme.colors.blueHighlight};
  }
`,
);

export const ActionButtonContainer = styled.div`
  display: grid;
  grid-column-gap: ${({ theme }) => theme.space[0]}px;
  margin: ${({ theme }) => `-${theme.space[1]}px 0px;`};
  grid-auto-flow: column;
  justify-content: flex-start;

  // If we are using the Container, dont use the margin on the Button, handle spacing with grid-gap
  ${ActionButton} {
    margin: 0;
  }
`;
